import { Apis } from '../../app.constants.js';
import APIService from '../../APIService.js';
import { useRecoilValue } from 'recoil';
import { userInformationAtom } from '../../_states/auth.js';

type ActivityLogActionsType = {
  getActivityLogs: (data?: any) => Promise<any>;
};

const ActivityLogActions = (): ActivityLogActionsType => {

  const getActivityLogs = async (data:any) => {
    try {
      let url = `${Apis.getActivityLogs}?next_page=${data?.page || 1}&limit=${data?.limit || 20}&search=${data?.search || ''}`;
      const response = await APIService.get(url);
      return response;
    } catch (error) {
      console.error("Error fetching activity logs:", error);
      throw error;
    }
  };

  return {
    getActivityLogs,
  };
};

export { ActivityLogActions };
